import LegalLayout from "@/components/LegalLayout";

export default function LegalPage({ pageKey }) {
  return <LegalLayout pageKey={pageKey} />;
}
